import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { DialogActionButtons } from 'components/dialogs'
import { StatementOfConformitySignatureDto, statementOfConformitySignatureValidationSchema } from 'dtos/people'
import { Form, Formik } from 'formik'
import { NO_FILE_UPLOADED } from 'localConstants'

interface Props {
  initialValues: StatementOfConformitySignatureDto
  loading: boolean
  onClose: () => void
  onSave: (values: StatementOfConformitySignatureDto) => void
  open: boolean
}

export default function StatementOfConformitySignatureEditDialog({ initialValues, loading, onClose, onSave, open }: Props) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange
        validationSchema={statementOfConformitySignatureValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, setFieldValue, values }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2} alignItems='center'>
                <DialogTitle>Statement of Conformity Signature</DialogTitle>

                <Grid item xs={12}>
                  <input
                    accept='.png,.jpg,.jpeg'
                    hidden
                    type='file'
                    id='statementOfConformitySignatureFile'
                    onChange={e => {
                      if (e.target.files && e.target.files.length > 0) {
                        setFieldValue('statementOfConformitySignatureFile', e.target.files[0])
                      }
                    }}
                  />

                  <Button
                    disabled={loading || isSubmitting}
                    onClick={() => {
                      document.getElementById('statementOfConformitySignatureFile')?.click()
                    }}
                    variant='contained'
                  >
                    UPLOAD SIGNATURE
                  </Button>

                  <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                    {values.statementOfConformitySignatureFile?.name ?? values.statementOfConformitySignatureFileName ?? NO_FILE_UPLOADED}
                  </Typography>

                  {errors.statementOfConformitySignatureFile && (
                    <Typography color='error' variant='body2' sx={{ mt: 1 }}>
                      {errors.statementOfConformitySignatureFile}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <GreenText variant='outlined'>
                    {`All fields are required.

Signature must be uploaded to save.

Image formats accepted:
  - .PNG,
  - .JPG, or
  - .JPEG

Maximum file size for upload: 20 MB`}
                  </GreenText>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActionButtons disabled={loading || isSubmitting} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
